import { useState, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import CustomSelect from "../../../common/customSelect";
import { CUSTOM_SELECT_COLOR_BLUE, CUSTOM_SELECT_COLOR_WHITE } from "../../../common/customSelect/constants";
import { PrescriptionContextMemorySpace } from "../../../../contexts/orden-medica/prescriptionContext";
import usePagination from "../hooks/usePagination";
import ReactGA from "react-ga4";

const HeaderSearch = () => {
  const [closeFamily, setCloseFamily] = useState(false);
  const {
    familyGroupList,
    activeKey,
    setCurrentIdSap,
    searchText,
    setSearchText,
    familyItem,
    setFamilyItem,
    setActiveKey,
  } = useContext(PrescriptionContextMemorySpace);

  const { obtenerResultados, searchData, applyFilters } = usePagination();
  const [closeAno, setCloseAno] = useState(false);
  const [closeService, setCloseService] = useState(false);
  const [year, setYear] = useState("Todos");
  const [offset, setOffset] = useState(0);

  const changeidSap = (id, name, text) => {
    setSearchText("");
    setYear("Todos");
    setFamilyItem(text);
    setCurrentIdSap(id);

    obtenerResultados(id);

    setActiveKey(0);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const clickIdSap = () => {
    setCloseFamily(false);
  };

  const yearsList = (() => {
    const now = new Date();
    const year = now.getFullYear();
    const listaAnos = [{ id: "Todos", name: "Todos" }];
    const anos = year - 2017;

    for (var i = 0; i <= anos; i++) {
      listaAnos.push({ id: year - i, name: year - i });
    }

    return listaAnos;
  })();

  const onChangeYear = (id, name, text) => {
    setYear(id);
    setOffset(0);
    applyFilters(searchText, id);
  };

  const clickYear = () => {
    ReactGA.event({
      category: "Acciones-Resultados",
      action: "click",
      label: "anio-estudios",
    });
    setCloseFamily(true);
    setCloseService(true);
    setCloseAno(false);
  };

  return (
    <div className="row">
      <div className="item-1" id="findUserName">
        <div className="input-icons me-3" style={{ position: "relative" }}>
          <FontAwesomeIcon icon={faSearch} className="custom-icon-results" />
          <input
            value={searchText}
            className="input-field-results"
            type="text"
            placeholder="Buscar"
            onChange={searchData}
          />
        </div>
      </div>

      <div className="item-2 col-years-results">
        <div id="title-study-results" style={{ width: "112px" }}>
          <span className="año-estudio">Año de la orden</span>
        </div>
        <div style={{ position: "relative", width: "111px" }}>
          <CustomSelect
            close={closeAno}
            defaultText={year}
            optionsList={yearsList}
            type={CUSTOM_SELECT_COLOR_WHITE}
            onChange={onChangeYear}
            onClick={clickYear}
            width="111px"
            name="year"
            paddingTop="1rem"
            fontFamily="Roboto-Regular"
          />
        </div>
      </div>

      <div
        className="item-3 item-3-prescription"
        style={{ marginBottom: "0rem" }}
      >
        <div
          id="dropdown-name"
          style={{ position: "relative", maxWidth: "250px" }}
        >
          <CustomSelect
            defaultText={familyItem}
            optionsList={familyGroupList ?? [{ id: "", name: "" }]}
            type={CUSTOM_SELECT_COLOR_BLUE}
            width="100%"
            name="family"
            onChange={changeidSap}
            onClick={clickIdSap}
            fontFamily="Roboto-Regular"
            close={closeFamily}
          />
        </div>
      </div>
    </div>
  );
};

export default HeaderSearch;
